import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Button, ListGroup } from "react-bootstrap";
import "./PromoBanner.css";
import SocialProfiler from "../../assets/Images/SocialProfiler.png";
import labelNew from "../../assets/Images/Lable- NEW.svg";
import checkmark from "../../assets/Icons/SVG/Check-Mark-Social e-Profiler Banner.svg";
import { ListItem } from "@mui/material";

const handleRedirect = () => {
  window.open("https://www.socialeprofiler.com", "_blank", "noopener,noreferrer");
}
const PromoBanner = () => {
  return (
    <Container
      fluid
      className="promo-banner"
      style={{
        backgroundImage: `url(${SocialProfiler})`,
        borderRadius: "10px",
        width: "100%",
        height: "200px",
        marginTop: "20px",
        marginBottom: "30px",
      }}
    >
      <Row>
        <div className="badgeNew">
          <a
            className="text-reset text-decoration-none"
            href="https://www.socialeprofiler.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <h4>
              <img className="img-new" src={labelNew} alt="labelNew" />
              <span className="span-background text-color">
                Social e-Profiler
              </span>
            </h4>
          </a>
        </div>
      </Row>
      <Row style={{ marginTop: 10 }}>
        <Col md={2}></Col>
        <Col md={4}>
          <div className="div-Socialcanvass">
            <h4 className="h4-Socialcanvass">
              Not Sure if You Need a Social Canvass?
            </h4>
            <p style={{ color: "black" }}>
              Try our new{" "}
              <span className="badge badge-danger">Social e-Profiler</span> to
              quickly identify if a Social Canvass is right for your claim/case.
            </p>
          </div>
        </Col>
        <Col md={4}>
          <ListGroup style={{ padding: "0", marginTop: "30px" }}>
            <ListItem style={{ padding: "0", margin: "0" }}>
              <img src={checkmark} alt="Checkmark Icon" />
              <span className="text-span">Unlock Digital Footprints</span>
            </ListItem>
            <ListItem style={{ padding: "0", margin: "0" }}>
              <img src={checkmark} alt="Checkmark Icon" />
              <span className="text-span">Fast and Efficient</span>
            </ListItem>
            <ListItem style={{ padding: "0", margin: "0" }}>
              <img src={checkmark} alt="Checkmark Icon" />
              <span className="text-span"> Simplify Your Investigations</span>
            </ListItem>
            <ListItem style={{ padding: "0", margin: "0" }}>
              <img src={checkmark} alt="Checkmark Icon" />
              <span className="text-span">Advanced Search Capabilities</span>
            </ListItem>
          </ListGroup>
        </Col>
        <Col md={2} className="button-reg">
          <Button onClick={handleRedirect} variant="primary">
            Register Today
          </Button>
          <a className="more" href="https://intertelinc.com/services/social-media-investigation/social-e-profiler" target="_blank">
            Click here to learn more.
          </a>
        </Col>
      </Row>
    </Container>
  );
};

export default PromoBanner;
